export const DATA_TRANSFER_ITEM_KINDS = {
    FILE: 'file',
};

export const ELEMENT_CLIPBOARD_UNDO = 'ELEMENT_CLIPBOARD_UNDO';
export const ELEMENT_CLIPBOARD_SAVE = 'ELEMENT_CLIPBOARD_SAVE';
export const ELEMENT_CLIPBOARD_PASTE = 'ELEMENT_CLIPBOARD_PASTE';
export const PASTE_OFFSET_Y = 2;
export const PASTE_OFFSET_X = 2;

// Carries the elements payload inside the HTML of a copy written through the async Clipboard API: custom
// data types written that way are never exposed to the paste event, while data-* attributes survive the
// browser's HTML sanitiser
export const ELEMENTS_PAYLOAD_ATTRIBUTE = 'data-milanote-elements';

export enum ClipboardOperation {
    cut = 'cut',
    copy = 'copy',
}
